(function() {
    'use strict';

    angular.module('allegro').controller('AccountUpdateController', AccountUpdateController);

    AccountUpdateController.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroAccountDataSrvc',
        'allegroAccountMessagesConst'
    ];

    function AccountUpdateController(
        $scope,
        $state,
        $stateParams,
        notificationSrvc,
        errorNotificationSrvc,
        allegroAccountDataSrvc,
        allegroAccountMessagesConst
    ){
        var self = this;
        self.loading = false;

        self.serverErrors = {
            nonFieldErrors: [],
            name: [],
            email: [],
        };

        self.account = {};
        self.accountData = {
            pk: null,
            name: '',
            email: '',
        };

        self.getAccount = getAccount;
        self.updateAccount = updateAccount;
        self.cleanErrors = cleanErrors;

        active()
        function active(){
            getAccount($stateParams.pk);
        }

        function getAccount(accountPk) {
            self.loading = true;

            return allegroAccountDataSrvc.get({pk: accountPk})
                .$promise
                .then(function (response) {
                    self.account = Object.assign(self.account, response);
                    self.accountData = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function updateAccount() {
            self.loading = true;

            return allegroAccountDataSrvc.update({pk: self.account.pk}, self.accountData)
                .$promise
                .then(function (response) {
                    self.accountData = response;
                    $state.go('layout.allegro-accounts.detail.overview', {pk: self.account.pk});
                    notificationSrvc.notification("success", allegroAccountMessagesConst.update);
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 400) {
                        errorNotificationSrvc.displayErrors(response.data);
                        self.serverErrors = response.data;
                    }

                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
